import { Box, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Table from '../../../components/Table/Table';
import Button from '../../../components/Button/Button';
import ErrorExclamationTriangularFilledIcon from '../../../components/Icons/ErrorExclamationTriangularFilledIcon';
import ArrowLeft from '../../../components/Icons/ArrowLeft';
import useBulkImportEditRows from './useBulkImportEditRows';

interface BulkImportEditRowsProps {
  onBack: () => void;
}

function BulkImportEditRows({ onBack }: BulkImportEditRowsProps) {
  const [t] = useTranslation();
  const theme = useTheme();
  const { headers, rows, proceedHandler, errorsDetected } = useBulkImportEditRows();

  return (
    <>
      <Box sx={{ paddingBottom: '2rem', marginTop: '1rem' }}>
        {errorsDetected ? (
          <>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
              <ArrowLeft stroke={theme.palette.primary.main} style={{ cursor: 'pointer' }} onClick={onBack} />
              <Typography
                sx={{ fontWeight: '700', fontSize: '1.25rem', marginLeft: '0.5rem' }}
                variant="body1"
                lineHeight="normal"
              >
                {t('pages.bulkImport.errorsDetected')}
              </Typography>
            </Box>
            <Typography variant="body1" lineHeight="normal">
              {t('pages.bulkImport.errorsHelper')}
            </Typography>
          </>
        ) : null}
      </Box>
      <Table headers={headers} rows={rows} />
      <Box sx={{ display: 'flex', alignItems: 'center', paddingTop: '2.5rem', paddingBottom: '3rem' }}>
        {errorsDetected ? (
          <Box sx={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <ErrorExclamationTriangularFilledIcon />
            <Typography variant="body1" sx={{ color: theme.palette.state.error }}>
              {t('pages.bulkImport.warning')}
            </Typography>
          </Box>
        ) : null}
        <Button sx={{ marginLeft: 'auto' }} onClick={proceedHandler} label={t('pages.bulkImport.excludeProceed')} />
      </Box>
    </>
  );
}

export default BulkImportEditRows;
